/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Request_TitleInputs */

const en_reset_request_title = /** @type {(inputs: Reset_Request_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset your password`)
};

/** @type {(inputs: Reset_Request_TitleInputs) => LocalizedString} */
const ar_reset_request_title = en_reset_request_title;

/** @type {(inputs: Reset_Request_TitleInputs) => LocalizedString} */
const he_reset_request_title = en_reset_request_title;

/** @type {(inputs: Reset_Request_TitleInputs) => LocalizedString} */
const ur_reset_request_title = en_reset_request_title;

/** @type {(inputs: Reset_Request_TitleInputs) => LocalizedString} */
const es_reset_request_title = en_reset_request_title;

/** @type {(inputs: Reset_Request_TitleInputs) => LocalizedString} */
const fr_reset_request_title = en_reset_request_title;

/** @type {(inputs: Reset_Request_TitleInputs) => LocalizedString} */
const de_reset_request_title = en_reset_request_title;

/** @type {(inputs: Reset_Request_TitleInputs) => LocalizedString} */
const pt_reset_request_title = en_reset_request_title;

/** @type {(inputs: Reset_Request_TitleInputs) => LocalizedString} */
const hi_reset_request_title = en_reset_request_title;

/** @type {(inputs: Reset_Request_TitleInputs) => LocalizedString} */
const bn_reset_request_title = en_reset_request_title;

/**
* | output |
* | --- |
* | "Reset your password" |
*
* @param {Reset_Request_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const reset_request_title = /** @type {((inputs?: Reset_Request_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Request_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_reset_request_title(inputs)
	if (locale === "he") return he_reset_request_title(inputs)
	if (locale === "ur") return ur_reset_request_title(inputs)
	if (locale === "es") return es_reset_request_title(inputs)
	if (locale === "fr") return fr_reset_request_title(inputs)
	if (locale === "de") return de_reset_request_title(inputs)
	if (locale === "pt") return pt_reset_request_title(inputs)
	if (locale === "hi") return hi_reset_request_title(inputs)
	if (locale === "bn") return bn_reset_request_title(inputs)
	return /** @type {LocalizedString} */ ("Reset your password")
});